/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    CURRENT_ROAM_RECEIVE,
    CURRENT_ROAM_REQUEST,
    CURRENT_ROAM_REQUEST_SUCCESS,
    CURRENT_ROAM_REQUEST_FAILURE,
} from 'state/action-types';

export const requesting = createReducer(false, {
    [CURRENT_ROAM_REQUEST]: () => true,
    [CURRENT_ROAM_REQUEST_SUCCESS]: () => false,
    [CURRENT_ROAM_REQUEST_FAILURE]: () => false,
});

const items = createReducer(null, {
    [CURRENT_ROAM_RECEIVE]: (state, action) => action.payload.roam,
});

export const error = createReducer(false, {
    [CURRENT_ROAM_REQUEST]: () => false,
    [CURRENT_ROAM_REQUEST_SUCCESS]: () => false,
    [CURRENT_ROAM_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
